import React from "react";
import { Shimmer } from "Shimmers";

import "./styles.scss";

const ShimmerCompanyCard = () => {
  const fakeTags = ["1", "2", "3"];

  const tagsHtml = fakeTags.map((tag, index) => {
    return (
      <Shimmer
        key={index}
        shimmerStyles={{
          height: "27px",
          width: "85px",
          borderRadius: "20px",
          margin: "5px 5px 0 0"
        }}
      />
    );
  });

  return (
    <div>
      <div className="ps-company-card ps-card--primary ps-card--auto-height">
        <Shimmer
          shimmerStyles={{
            position: "relative",
            maxWidth: "100%",
            maxHeight: "0",
            width: "100%",
            paddingTop: "47.62%",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px"
          }}
        />

        <div className="ps-company-card__body">
          <Shimmer
            shimmerStyles={{
              height: "80px",
              width: "80px",
              borderRadius: "50%",
              marginTop: "-65px",
              position: "relative",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
            }}
          />

          <div className="ps-company-card__text-container">
            <Shimmer
              shimmerStyles={{
                marginTop: "7px",
                height: "23px",
                width: "110px",
                borderRadius: "4px"
              }}
            />

            <div className="ps-company-card__tags-container">{tagsHtml}</div>

            <Shimmer
              shimmerStyles={{
                height: "15px",
                width: "100%",
                borderRadius: "4px",
                marginBottom: "10px",
                marginTop: "10px"
              }}
            />

            <Shimmer
              shimmerStyles={{
                height: "15px",
                width: "100%",
                borderRadius: "4px",
                marginBottom: "10px"
              }}
            />

            <Shimmer
              shimmerStyles={{
                height: "15px",
                width: "35%",
                borderRadius: "4px",
                marginBottom: "10px"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { ShimmerCompanyCard }
